import { render, staticRenderFns } from "./HolidayBalance.vue?vue&type=template&id=20da1810"
import script from "./HolidayBalance.vue?vue&type=script&lang=js"
export * from "./HolidayBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports